<template>
  <CustomTable title="" :rowsData="this.rowsData" :columns="this.constructivesPriceColumns" :loading="isFetching"
    :custom-body="true" :small="true" :sticky-header="false" :add-btn="true" :on-add-click="this.onAddClick"
    :addBtnTitle="'Добавить цену'">
    <template #customBody="props">
      <q-tr>
        <custom-table-cell align="center" verticalAlign="center">
          {{ props.row.contractor_work_set_tariff_id }}
        </custom-table-cell>

        <custom-table-cell align="center" verticalAlign="center">
          {{ numberWithCommas(props.row.contractor_work_set_price) }}
        </custom-table-cell>

        <custom-table-cell align="center" verticalAlign="center">
          {{ props.row.valid_date }}
        </custom-table-cell>

        <custom-table-cell align="center" vertical-align="center" style="width: 100px; min-width: 100px;">
          <div style="display: flex; justify-content: center; align-items: center; height: 32px; gap: 8px;">
            <CustomButton color="primary-light" @click="onEditClick(props.row)"
              style="width: 32px; height: 32px; min-height: 32px; padding: 0;">
              <q-icon name="edit" size="16px" />
            </CustomButton> 
            <CustomButton color="negative" :loading="isDeleting"
              @click="handleDeletePrice(props.row.contractor_work_set_tariff_id)"
              style="width: 32px; height: 32px; min-height: 32px; padding: 0;">
              <q-icon name="delete" size="16px" />
            </CustomButton>
          </div>
        </custom-table-cell>
      </q-tr>
    </template>
  </CustomTable>
</template>

<script>
import { useCustomSnackbar } from '@/_helpers/hooks/useCustomSnackbar'
import Clickable from '@/components/common/Clickable'
import CustomIcon from '@/components/common/CustomIcon'
import CustomPopup from '@/components/common/CustomPopup'
import CustomTable from '@/components/common/CustomTable'
import CustomTableCell from '@/components/common/CustomTable/custom-table-cell'
import SvgIcon from '@/components/common/SvgIcon'
import CustomCheckbox from '@/components/form/CustomCheckbox'
import { MODAL_NAMES } from '@/constants'
import { useAppStore } from '@/services/store/app'
import { constructivesPriceColumns, getConstructivesPriceList, deleteConstructivesPrice, updConstructivesPrice, addConstructivesPrice } from './services'
import { numberWithCommas } from "@/services"
import CustomButton from '@/components/common/CustomButton'

export default {
  name: 'LinksTable',
  components: {
    CustomIcon,
    CustomTableCell,
    CustomTable,
    CustomPopup,
    SvgIcon,
    CustomCheckbox,
    Clickable,
    CustomButton,
  },
  props: ['contractor_work_set_id', 'onDataChange'],
  data() {
    return {
      constructivesPriceColumns,
      rowsData: [],
      isFetching: false,
      params: {
        contractor_work_set_id: this.contractor_work_set_id,
      },
      isDeleting: false,
    }
  },
  methods: {
    numberWithCommas,
    onAddClick() {
      this.showModal(MODAL_NAMES.AddConstructivePrice, {
        title: 'Добавить цену',
        onSubmit: this.handlePriceAdd,
        body: { contractor_work_set_id: this.contractor_work_set_id },
      })
    },
    onEditClick(row) {
      this.showModal(MODAL_NAMES.AddConstructivePrice, {
        title: 'Редактировать цену',
        onSubmit: body => this.handlePriceEdit(body),
        body: row,
      })
    },
    async handlePriceEdit(body) {
      this.isFetching = true;
      const res = await updConstructivesPrice(body);
      this.isFetching = false;
      if (!res) {
        return;
      }
      this.rowsData = res || [];
      this.showSucceedSnackbar();
      this.refreshData()
      this.closeModal();
    },
    async handlePriceAdd(body) {
      this.isFetching = true;
      const res = await addConstructivesPrice(body);
      this.isFetching = false;
      if (!res) {
        return;
      }
      this.rowsData = res || [];
      this.showSucceedSnackbar();
      this.refreshData()
      this.closeModal();
    },
    async getData() {
      this.isFetching = true
      const body = {
        contractor_work_set_id: this.contractor_work_set_id,
      }
      const res = await getConstructivesPriceList(body)
      this.isFetching = false
      if (!res) return
      this.rowsData = res || []
    },
    async handleDeletePrice(contractor_work_set_tariff_id) {
      this.isDeleting = true
      const res = await deleteConstructivesPrice(contractor_work_set_tariff_id)
      this.isDeleting = false
      if (!res) return
      if (res.length === 0) {
        this.refreshData()
      } else {
        this.rowsData = res || []
      }
      this.showSucceedSnackbar()
    },
    refreshData() {
      this.$emit('refresh-data');
    },
  },
  mounted() {
    this.getData()
  },
  setup() {
    const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar()
    const { showModal, closeModal } = useAppStore()
    return { showSucceedSnackbar, showErrorSnackbar, showModal, closeModal }
  },
}
</script>

<style scoped lang="scss">
.link {
  color: #00368b;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
}
</style>